
import Vue from "vue";
import Feature from "./Feature.vue";

export default Vue.extend({
  name: "HomeFeatures",
  components: { Feature },
});
